<template>
  <textarea
    :id="name"
    ref="textarea"
    :class="{ 'is-invalid': errors }"
    :name="name"
    :placeholder="label"
    :style="getStyle()"
    :value="value"
    class="form-control p-2"
    @change="$emit('update:data', $event.target.value)"
    @focus="resize"
    @keyup="updateMirror($event.target.value)"
  >
  </textarea>
</template>

<script>
import { onMounted, ref } from 'vue';

export default {
  props: {
    name: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    errors: { type: Array, default: null },
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    rows: { type: Number, default: 1 },
    options: { type: Object, default: () => {} },
  },
  emits: ['update:data', 'update:mirror'],
  setup(props, { emit }) {
    const textarea = ref(null);
    const resize = () => {
      if (props.options && props.options.noResize) {
        return;
      }

      textarea.value.style.height = '1px';
      textarea.value.style.height =
        Math.max(
          props.rows * parseFloat(getComputedStyle(document.documentElement).fontSize),
          parseInt(textarea.value.scrollHeight)
        ) +
        2 +
        'px';
    };
    const updateMirror = (value) => {
      resize();
      emit('update:mirror', value);
    };

    const getStyle = () => {
      if (props.options?.style) {
        return props.options.style;
      }

      return (
        'resize: none; max-height: 15rem; min-height:15rem; ' +
        (props.options && props.options.noResize ? ' height:15rem;' : '')
      );
    };

    onMounted(() => {
      resize();
    });

    return {
      getStyle,
      resize,
      textarea,
      updateMirror,
    };
  },
};
</script>

<style lang="scss" scoped></style>
